export default __webpack_public_path__ + "static/media/partners-logo-techstorm-w.c356d7a6.webp";